import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col py-4 rounded" }
const _hoisted_2 = { class: "text-2xl" }
const _hoisted_3 = { class: "flex flex-row mb-2 justify-end" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "flex flex-row mt-4" }
const _hoisted_7 = { class: "flex flex-col pr-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700 mb-4" }, "COMPLETED"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700 mb-4 pl-8" }, "ACCESS"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700 mb-4 pl-80" }, "RESULTS")
], -1 /* HOISTED */)
const _hoisted_9 = { class: "flex flex-row items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-3 inline-block" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "flex flex-row items-center mt-1" }
const _hoisted_14 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_15 = ["id", "onClick"]
const _hoisted_16 = { class: "flex flex-row items-center" }
const _hoisted_17 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_18 = ["id", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlButton = _resolveComponent("SlButton")!
  const _component_SetResultItem = _resolveComponent("SetResultItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.game.name), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_SlButton, {
        disabled: !_ctx.showSave,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveParticipant()))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createCommentVNode(" No Access Option "),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", {
            id: "p-access-noaccess",
            class: "rounded-sm ml-32 p-1 border-dashed border border-gray-400",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.settAccess('noaccess')))
          }, "No Access")
        ]),
        _createCommentVNode(" CMS-based levels "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cmsroot, (week, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: week._id,
            class: "flex flex-col"
          }, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(index + 1), 1 /* TEXT */),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                id: `input-completed-${week._id}`,
                "onUpdate:modelValue": ($event: any) => ((_ctx.hierarchyAsDict[week._id].completed) = $event),
                type: "checkbox",
                onChange: ($event: any) => (_ctx.settComplete(week._id))
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_14), [
                [_vModelCheckbox, _ctx.hierarchyAsDict[week._id].completed]
              ]),
              _createElementVNode("p", {
                id: `p-access-${week._id}`,
                class: "ml-32 w-96",
                onClick: ($event: any) => (_ctx.settAccess(week._id))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["rounded-sm p-1 border-dashed border border-gray-400", {
                  'bg-sl-green-button': _ctx.hierarchyAsDict[week._id].accessible,
                }])
                }, _toDisplayString(week.name), 3 /* TEXT, CLASS */)
              ], 8 /* PROPS */, _hoisted_15),
              _createVNode(_component_SetResultItem, {
                completions: _ctx.results[week._id]
              }, null, 8 /* PROPS */, ["completions"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week.sets, (day) => {
              return (_openBlock(), _createElementBlock("div", {
                key: day._id,
                class: "flex flex-col"
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    id: `input-completed-${day._id}`,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.hierarchyAsDict[day._id].completed) = $event),
                    type: "checkbox",
                    onChange: ($event: any) => (_ctx.settComplete(day._id))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_17), [
                    [_vModelCheckbox, _ctx.hierarchyAsDict[day._id].completed]
                  ]),
                  _createElementVNode("p", {
                    id: `p-access-${day._id}`,
                    class: "pl-4 ml-32 w-96",
                    onClick: ($event: any) => (_ctx.settAccess(day._id))
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["rounded-sm p-1 border-dashed border border-gray-400", {
                    'bg-sl-green-button': _ctx.hierarchyAsDict[day._id].accessible,
                  }])
                    }, _toDisplayString(day.name), 3 /* TEXT, CLASS */)
                  ], 8 /* PROPS */, _hoisted_18),
                  _createVNode(_component_SetResultItem, {
                    completions: _ctx.results[day._id]
                  }, null, 8 /* PROPS */, ["completions"])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}